(()=>{
  const SAVED_KEY='2in1flags:design:saved:v1';
  const MY_DESIGNS='https://account.2in1flags.com/pages/01a082eb-52b3-7be3-a032-b9482cd0707a';
  const MAX_SAVED=100;
  const round=value=>Math.round(value*100000)/100000;
  const safeRemote=url=>typeof url==='string'&&/^https:\/\//i.test(url)&&!url.startsWith('data:');

  function customerId(){return document.documentElement.getAttribute('data-customer-id')||'';}
  function savedKeys(){
    const keys=[SAVED_KEY];
    const id=customerId();
    if(id)keys.push(`${SAVED_KEY}:${id}`);
    return keys;
  }
  function readSavedList(key){
    try{
      const value=JSON.parse(localStorage.getItem(key)||'[]');
      return Array.isArray(value)?value:[];
    }catch(_){return[];}
  }
  function readSaved(){
    const byId=new Map();
    const add=item=>{
      if(!item?.id)return;
      const prev=byId.get(item.id);
      if(!prev||new Date(item.updatedAt||item.createdAt||0)>new Date(prev.updatedAt||prev.createdAt||0))byId.set(item.id,item);
    };
    savedKeys().forEach(key=>readSavedList(key).forEach(add));
    try{
      const parsed=JSON.parse(document.getElementById('hfd-account-payload')?.textContent||'{}');
      (Array.isArray(parsed.designs)?parsed.designs:[]).forEach(add);
    }catch(_){}
    return [...byId.values()].sort((a,b)=>new Date(b.updatedAt||b.createdAt||0)-new Date(a.updatedAt||a.createdAt||0));
  }
  function writeSaved(items){
    const payload=JSON.stringify(items.slice(0,MAX_SAVED));
    savedKeys().forEach(key=>{
      try{localStorage.setItem(key,payload);}catch(error){console.warn('2in1Flags account save failed',key,error);}
    });
  }
  function escapeHtml(value){return String(value??'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));}

  function mergeExactState(safe){
    try{
      const exact=window.twoInOneSavedDesignState?.();
      if(!exact?.front||!exact?.back||!safe?.design)return;
      safe.design.front=JSON.parse(JSON.stringify(exact.front));
      safe.design.back=JSON.parse(JSON.stringify(exact.back));
      safe.design.side=exact.side||safe.design.side||'front';
    }catch(error){console.warn('2in1Flags exact design state merge skipped',error);}
  }

  function captureActivePresentation(safe){
    try{
      const root=document.querySelector('[data-hfd]');if(!root)return;
      const sideName=root.querySelector('[data-side].is-active')?.dataset.side||safe?.design?.side||'front';
      const side=safe?.design?.[sideName];if(!side?.items?.length)return;
      const layers=window.hfdUi?.nodes(root,sideName,'[data-layer]')||[...root.querySelectorAll('[data-layer]')];
      side.items.forEach((flag,index)=>{
        if(flag?.type==='text')return;
        const layer=layers[index],img=layer?.querySelector('img');if(!layer||!img)return;
        const lr=layer.getBoundingClientRect(),ir=img.getBoundingClientRect();
        const imageUrl=img.currentSrc||img.src||'';
        if(safeRemote(imageUrl))flag.imageUrl=imageUrl;
        if(lr.width&&lr.height&&ir.width&&ir.height){
          flag.presentation={
            x:round((ir.left-lr.left)/lr.width),y:round((ir.top-lr.top)/lr.height),
            w:round(ir.width/lr.width),h:round(ir.height/lr.height)
          };
        }
        try{if(img.dataset.visibleBounds)flag.visibleBounds=JSON.parse(img.dataset.visibleBounds);}catch(_){ }
        if(img.naturalWidth)flag.naturalWidth=img.naturalWidth;
        if(img.naturalHeight)flag.naturalHeight=img.naturalHeight;
      });
    }catch(error){console.warn('2in1Flags active presentation capture skipped',error);}
  }

  function sanitizeItem(item){
    try{
      const safe=JSON.parse(JSON.stringify(item||{}));
      mergeExactState(safe);
      captureActivePresentation(safe);
      [safe?.design?.front,safe?.design?.back].forEach(side=>side?.items?.forEach(flag=>{
        if(flag.imageUrl&&!safeRemote(flag.imageUrl))delete flag.imageUrl;
        if(flag.previewUrl&&!safeRemote(flag.previewUrl))delete flag.previewUrl;
        if(typeof flag.value==='string'&&flag.value.startsWith('data:'))delete flag.value;
      }));
      return safe;
    }catch(_){return null;}
  }

  function encodeItem(item){
    try{
      const bytes=new TextEncoder().encode(JSON.stringify(item));
      let binary='';
      bytes.forEach(byte=>binary+=String.fromCharCode(byte));
      return btoa(binary).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
    }catch(_){return '';}
  }

  function shrinkDataUrl(dataUrl,maxEdge=400,quality=0.5){
    return new Promise(resolve=>{
      if(!dataUrl||!String(dataUrl).startsWith('data:image/')){resolve('');return;}
      const img=new Image();
      img.onload=()=>{
        try{
          const scale=Math.min(1,maxEdge/Math.max(img.naturalWidth||1,img.naturalHeight||1));
          const w=Math.max(1,Math.round((img.naturalWidth||1)*scale));
          const h=Math.max(1,Math.round((img.naturalHeight||1)*scale));
          const canvas=document.createElement('canvas');
          canvas.width=w;canvas.height=h;
          const ctx=canvas.getContext('2d');
          ctx.fillStyle='#ffffff';
          ctx.fillRect(0,0,w,h);
          ctx.drawImage(img,0,0,w,h);
          resolve(canvas.toDataURL('image/jpeg',quality));
        }catch(_){resolve('');}
      };
      img.onerror=()=>resolve('');
      img.src=dataUrl;
    });
  }

  async function collectLibraryUploads(){
    const byId=new Map();
    async function add(raw){
      if(!raw?.id||!raw.dataUrl||byId.has(raw.id))return;
      const dataUrl=await shrinkDataUrl(raw.dataUrl);
      if(!dataUrl)return;
      byId.set(raw.id,{
        id:String(raw.id),
        name:String(raw.name||'Custom Image').slice(0,80),
        dataUrl,
        private:!!raw.private,
        createdAt:new Date().toISOString(),
        updatedAt:new Date().toISOString()
      });
    }
    const state=window.__hfdUploadState||{};
    for(const side of ['front','back']){
      for(const slot of state[side]||[]){
        if(slot?.enabled&&slot.dataUrl)await add(slot);
      }
    }
    return [...byId.values()].slice(0,8);
  }

  async function goToAccount(item){
    const safe=sanitizeItem(item);
    if(!safe?.id||!safe?.design?.front||!safe?.design?.back){
      console.warn('2in1Flags account import skipped: could not encode design');
      return;
    }
    const designOnly=encodeItem(safe);
    if(!designOnly){
      console.warn('2in1Flags account import skipped: could not encode design');
      return;
    }
    let uploads=[];
    try{uploads=await collectLibraryUploads();}catch(error){console.warn('2in1Flags upload library skipped',error);uploads=[];}
    const maxHash=400000;
    let packed=[];
    let withUploads=designOnly;
    for(const upload of uploads){
      const next=encodeItem({...safe,uploads:[...packed,upload]});
      if(!next||next.length>maxHash)break;
      packed=[...packed,upload];
      withUploads=next;
    }
    const maxPath=6000;
    if(designOnly.length<=maxPath){
      window.location.assign(`${MY_DESIGNS}/import/${encodeURIComponent(designOnly)}#${withUploads}`);
      return;
    }
    window.location.assign(`${MY_DESIGNS}/import#${withUploads}`);
  }

  document.addEventListener('flag:design-saved',event=>{
    const item=event.detail;
    if(!item?.id||!item?.design?.front||!item?.design?.back)return;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{goToAccount(item);}));
  });

  async function firstPreview(design,sideName){
    const items=[...((sideName==='back'?design?.back?.items:design?.front?.items)||[])];
    if(!items.length)items.push(...(design?.front?.items||[]),...(design?.back?.items||[]));
    for(const item of items){
      if(item?.imageUrl&&safeRemote(item.imageUrl))return item.imageUrl;
      if(item?.type==='country'&&item.value&&/^[a-z]{2}$/i.test(item.value))return `https://flagcdn.com/w80/${String(item.value).toLowerCase()}.png`;
    }
    return '';
  }

  async function renderAccountDesigns(){
    const host=document.querySelector('[data-account-designs]');
    if(!host)return;
    const saved=readSaved();
    if(!saved.length){
      host.innerHTML=`<p class="account-designs__empty">No saved flag designs yet. Use <strong>Save Design</strong> on the homepage designer.</p><p><a class="button" href="${MY_DESIGNS}">Open My Designs</a></p>`;
      return;
    }
    const cards=[];
    for(const item of saved){
      let frontPreview='';
      let backPreview='';
      try{frontPreview=await firstPreview(item.design,'front');}catch(_){frontPreview='';}
      try{backPreview=await firstPreview(item.design,'back');}catch(_){backPreview='';}
      const date=item.updatedAt||item.createdAt?new Date(item.updatedAt||item.createdAt).toLocaleString():'';
      cards.push(`<article class="account-designs__card" data-saved-id="${escapeHtml(item.id)}">
        <div class="account-designs__preview">
          <span><small>Front Design</small>${frontPreview?`<img src="${escapeHtml(frontPreview)}" alt="Front Design">`:'<span>No preview</span>'}</span>
          <span><small>Back Design</small>${backPreview?`<img src="${escapeHtml(backPreview)}" alt="Back Design">`:'<span>No preview</span>'}</span>
        </div>
        <div class="account-designs__meta">
          <strong>${escapeHtml(item.name||'My Flag Design')}</strong>
          <small>${escapeHtml(date)}</small>
          <label class="account-designs__visible"><input type="checkbox" data-toggle-visible ${item.visible===false?'':'checked'}><span>Visible to all</span></label>
        </div>
        <div class="account-designs__actions"><a href="${MY_DESIGNS}">Account</a><button type="button" data-rename-account-design>Rename</button><button type="button" data-delete-account-design>Delete</button></div>
      </article>`);
    }
    host.innerHTML=`<div class="account-designs__grid">${cards.join('')}</div>`;
    host.onchange=event=>{
      const input=event.target.closest('[data-toggle-visible]');
      const card=event.target.closest('[data-saved-id]');
      if(!input||!card)return;
      const items=readSaved();
      const index=items.findIndex(x=>x.id===card.dataset.savedId);
      if(index<0)return;
      items[index].visible=!!input.checked;
      items[index].updatedAt=new Date().toISOString();
      writeSaved(items);
    };
    host.onclick=event=>{
      const card=event.target.closest('[data-saved-id]');
      if(!card)return;
      const items=readSaved();
      const index=items.findIndex(x=>x.id===card.dataset.savedId);
      if(index<0)return;
      if(event.target.closest('[data-rename-account-design]')){
        const name=prompt('Rename this flag:',items[index].name||'My Flag Design');
        if(name===null)return;
        const next=name.trim().slice(0,80);
        if(!next)return;
        items[index].name=next;
        items[index].updatedAt=new Date().toISOString();
        writeSaved(items);
        renderAccountDesigns();
        return;
      }
      if(!event.target.closest('[data-delete-account-design]'))return;
      if(!confirm(`Delete “${items[index].name}”?`))return;
      items.splice(index,1);
      writeSaved(items);
      renderAccountDesigns();
    };
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',renderAccountDesigns,{once:true});
  else renderAccountDesigns();
})();
